import { compose, filter, size } from 'lodash/fp';

export default compose(size, filter(['state', 0]));
